import { ticketClient } from "@/api/ticketClient";
import { CommonIn } from "@/pbjs/xcommon/common_pb";
import { DashboardReq } from "@/pbjs/xcommon/ticket_pb";
import { localGet, setMetaData } from "@/utils";
import { errorMsg, handleResponse } from "@/utils/request";
// import router from '@/router'
//  lee  获取角色分类
interface RoleOptions {
  trackId?: string;
  clientId?: string;
  token: string;
  userid: number;
}
export function getUrgeDashboardApi(arg: RoleOptions) {
  return new Promise((resolve, reject) => {
    (async () => {
      let common = new CommonIn();
      common.setTrackid("");
      common.setClientid("");
      common.setLang(localGet("cn") ? localGet("cn") : "zh-CN");
      common.setToken(arg.token);
      common.setUserid(arg.userid);
      let request = new DashboardReq();
      request.setUserid(Number(arg.userid));
      request.setCommonin(common);
      await ticketClient.getUrgeDashboard(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
